import moment from 'moment';

/** 订单时间接口格式，用于优先严格解析本地时间字符串。 */
const ORDER_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/** 订单时间字段允许的输入类型。 */
type OrderTimeValue = string | Date | null | undefined;

/**
 * 计算订单从开桌到结单的用餐时长。
 * @param startTime - 订单开桌时间
 * @param endTime - 订单结单时间
 * @returns 整数分钟；时间缺失、非法或顺序错误时返回 null
 */
export function getOrderDiningDurationMinutes(
    startTime: OrderTimeValue,
    endTime: OrderTimeValue,
): number | null {
    const start = parseOrderTime(startTime);
    const end = parseOrderTime(endTime);
    if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
        return null;
    }
    return end.diff(start, 'minutes');
}

/**
 * 按订单接口格式解析时间值。
 * @param value - 待解析的时间字符串或 Date
 * @returns Moment 时间对象
 */
function parseOrderTime(value: OrderTimeValue): moment.Moment {
    if (value == null || value === '') {
        return moment.invalid();
    }
    return typeof value === 'string'
        ? moment(value, [ORDER_TIME_FORMAT, moment.ISO_8601], true)
        : moment(value);
}
